import {
  DestroyRef,
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, Subscription } from 'rxjs';

type Breakpoint = 'mobile' | 'desktop';

const BREAKPOINTS: Record<Breakpoint, string> = {
  mobile: '(max-width: 1280px)',
  desktop: '(min-width: 1281px)',
};

@Directive({
  selector: '[zionBreakpointObserver]',
  standalone: true,
})
export class BreakpointObserverDirective {
  private breakpointObserver = inject(BreakpointObserver);
  private templateRef = inject(TemplateRef);
  private viewContainerRef = inject(ViewContainerRef);
  private destroyRef = inject(DestroyRef);

  private currentSubscription: Subscription | null = null;

  breakpoint = input.required<Breakpoint>({
    alias: 'zionBreakpointObserver',
  });

  effectRef = effect(() => {
    this.currentSubscription?.unsubscribe();

    const breakpoint = BREAKPOINTS[this.breakpoint()];

    this.currentSubscription = this.breakpointObserver
      .observe(breakpoint)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((result) => result.matches),
      )
      .subscribe((isBreakpointActive) => {
        if (isBreakpointActive) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainerRef.clear();
        }
      });
  });
}
